import type { Banner } from "../../@types/mapviewxs";
import { getPropsForClickTracking } from "../../utils/tracking";
import { STEPS_BANNER_KEY, PROMOTIONAL_BANNER_KEY } from "./const";
export interface Input {
  banners: Banner[];
  currentIndex: number;
  feedItemsLength: number;
  bannerInsertPositions: number[];
}
$ const { bannerInsertPositions, currentIndex, feedItemsLength, banners } = input;
$ const getBannerType = (index: number) => (index === 0 ? PROMOTIONAL_BANNER_KEY : STEPS_BANNER_KEY);
$ const totalBanners = bannerInsertPositions?.length || 0;
$ const bannersAtPosition = bannerInsertPositions?.filter((pos) => pos <= feedItemsLength) || [];
$ const remainingBannerCount = totalBanners - bannersAtPosition.length;
$ const isLastItem = currentIndex === feedItemsLength - 1;
$ const stepsBannerData = banners?.find((banner) => banner._type === STEPS_BANNER_KEY);
$ const promotionalBannerData = banners?.find((banner) => banner._type === PROMOTIONAL_BANNER_KEY);
$ const promotionalBannerCTA = promotionalBannerData?.actions?.[0];
$ const { fineprint } = promotionalBannerData || {};

<macro|{ bannerType, keyValue }: { bannerType: typeof STEPS_BANNER_KEY | typeof PROMOTIONAL_BANNER_KEY; keyValue: string }| name="renderBanner">
  <if(bannerType === STEPS_BANNER_KEY && stepsBannerData)>
    <section class="items-feed__banner" key=keyValue>
      <div class="steps-banner">
        <h2 class="steps-banner__title">
          <fe-textual-display model=stepsBannerData.title/>
        </h2>
        <div class="steps-banner__steps">
          <for|step, index| of=stepsBannerData.steps || []>
            <div class="steps-banner__step">
              <if(step.icon)>
                <div class="steps-banner__icon">
                  <img src=(step.icon.URL) alt=(step.icon.altText)>
                </div>
              </if>
              <div class="steps-banner__number">
                ${index + 1}
              </div>
              <div class="steps-banner__content">
                <h3 class="steps-banner__step-title">
                  <fe-textual-display model=step.title/>
                </h3>
                <if(step.subtitle)>
                  <p class="steps-banner__step-text">
                    <fe-textual-display model=step.subtitle/>
                  </p>
                </if>
              </div>
            </div>
          </for>
        </div>
      </div>
    </section>
  </if>
  <else-if(bannerType === PROMOTIONAL_BANNER_KEY && promotionalBannerData)>
    <section class="items-feed__banner items-feed__banner--collection" key=keyValue>
      <div class="collection-banner">
        <div class="collection-banner__content">
          <h2 class="collection-banner__title">
            <fe-textual-display model=promotionalBannerData.title/>
          </h2>
          <p class="collection-banner__subtitle">
            <fe-textual-display model=promotionalBannerData.subtitle/>
          </p>
          <ebay-button
            class="collection-banner__button"
            priority="primary"
            size="large"
            ...getPropsForClickTracking(promotionalBannerCTA?.action?.trackingList)
            href=(promotionalBannerCTA?.action?.URL)
            target="_blank"
            rel="noreferrer"
          >
            <fe-textual-display model=promotionalBannerCTA?.text/>
          </ebay-button>
          <if(fineprint?.action)>
            <a
              class="collection-banner__fineprint"
              ...getPropsForClickTracking(fineprint.action.trackingList)
              href=(fineprint.action.URL)
              target="_blank"
              rel="noreferrer"
              title=(fineprint.action.accessibilityText)
            >
              <fe-textual-display model=fineprint/>
            </a>
          </if>
        </div>
        <div class="collection-banner__image">
          <img src=(promotionalBannerData.image.URL) alt=(promotionalBannerData.image.altText)>
        </div>
      </div>
    </section>
  </else-if>
</macro>
<!-- Show banner at current position if applicable -->
<if(bannerInsertPositions?.includes(currentIndex + 1))>
  $ const bannerIndex = bannerInsertPositions.indexOf(currentIndex + 1);
  $ const bannerType = getBannerType(bannerIndex);
  <renderBanner bannerType=bannerType keyValue=`banner-insert-${currentIndex}`/>
</if>
<!-- Show remaining banners after the last item -->
<if(isLastItem && remainingBannerCount > 0)>
  $ const startBannerIndex = bannersAtPosition.length;
  <for|i| from=0 to=remainingBannerCount - 1>
    $ const currentBannerIndex = startBannerIndex + i;
    $ const bannerType = getBannerType(currentBannerIndex);
    <renderBanner bannerType=bannerType keyValue=`banner-remaining-${i}`/>
  </for>
</if>
